import PageModal from '@components/common/PageModal';
import React, { useEffect, useState } from 'react';
import endpoints from '@config/endpoints';
import axios from '../../../../utils/axiosExt';
import { setDistrictByStateId } from '@store/actions/zoneDetailsActions';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR_MESSAGES, healthBlockDivision } from '@constants/index';
import ZoneForm from '@pages/GeoNonGeo/ZoneForm';
import { update } from 'lodash';
import dayjs from 'dayjs';
import { validations } from '@pages/GeoNonGeo/Geo/GeoValidation';
import { useNavigate } from 'react-router-dom';
import CreateCommonComponent from '@components/common/CreateComponent';
import Auth from "../../../../utils/auth";

import { toast } from 'react-toastify';
import { getData, putDataJSON } from '../../../../services/CommonApiService';
import { errorLogger } from '@utils/applicationLogUtils';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import _ from 'lodash';
import { uint8ToBase64 } from '@utils/base64Utils';
import pako from 'pako';
import { manageHealthFacilityJson } from '../nonGeoValidations';
interface newNonGeoProps {
    // closeModal: () => void;
    show?: boolean;
    page?: string;
    flow?: string;
}

interface objectType {
    isError: boolean,
    message: string,
    isDisable?: boolean,
    value: any,
    id?: any,
    code?: any
}

export interface formStateType {
    [key: string]: objectType
}

interface formDataType {
    [key: string]: any;
  }
let STATE_ID: string = '';
let stateCode: string = '';
let DISTRICT_ID: string = '';
const CreateNewNonGeo: React.FC<newNonGeoProps> = ({ show, page }: newNonGeoProps) => {
    const [errors, setErrors] = useState<boolean[]>([]);
    const storedUserId = localStorage.getItem('userId');
    const [healthBlockFormState, setHealthBlockFormState] = useState<formStateType>({
        type_name: {
            isError: false,
            message: '',
            value: '',
            id:'',
            code:''
        },
        effective_form_date: {
            isError: false,
            message: '',
            value: '',
        },
        district: {
            isError: false,
            message: '',
            value: '',
            id:'',
            code:''
        },

        sub_district: {
            isError: false,
            message: '',
            value: '',
            id:'',
            code:''
        },

        ulb: {
            isError: false,
            message: '',
            value: '',
            id:'',
            code:''
        },
        wards_mapped: {
            isError: false,
            message: '',
            value: [],
            id:[],
            code:[]
        },

        block: {
            isError: false,
            message: '',
            value: '',
            id:'',
            code:''
        },
        villages_mapped: {
            isError: false,
            message: '',
            value: [],
            id:[],
            code:[]
        },
        gram_panchayat_mapped: {
            isError: false,
            message: '',
            value: [],
            id:[],
            code:[]
        },
        health_block_name: {
            isError: false,
            message: '',
            value: '',
            id:'',
            code:undefined
        },
    });
    const [healthBlockFormData, setHealthBlockFormData] = useState<any>(healthBlockDivision);

    const [navItemsModal, setnavItemsModal] = useState(['Enter Details']);
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [isFormValidated, setIsFormValidated] = useState<boolean>(false);
    const [isGramPanchayat, setIsGramPanchayat] = useState<boolean>(false);
    const [formCompleted, setFormCompleted] = useState<boolean[]>(
      Array(navItemsModal.length).fill(false),
    );
    const [closeModal,setCloseModal]=useState<boolean>(false)
    const [ulbInputText, setUlbInputText] = useState<string>('');
  
    const [selectPerc, setSelectedPerc] = useState<any>(0);
    const [wardsDropDownData, setWardsDropDownData] = useState<any>([]);
    const [ulbDropDownData, setUlbDropDownData] = useState<any>([]);
    const [villagesMappedDropDownData, setViillagesMappedDropDownData] = useState<any>([]);
    const [blockDropDownData, setBlockDropDownData] = useState<any>([]);
    const [subDistrictDropDownData, setSubDistrictDropDownData] = useState<any>([]);
    const [grampanchayatDropDownData, setGrampanchayatDropDownData] = useState<any>([]);

    const navs = 100 / navItemsModal.length;
    useEffect(()=>{
        const initialFetch=async ()=>{
            if (storedUserId) {
                try{
                const res = await getData<any[]>(`${endpoints.getUserById}/${storedUserId}`)
                DISTRICT_ID=res?.data[0]?.district_id;
                STATE_ID=res?.data[0]?.state_id;
                stateCode=res?.data[0]?.state_code;
                    setHealthBlockFormState({
                    ...healthBlockFormState,
                    district:{
                      ...healthBlockFormState.district,
                        value:res?.data[0]?.district_name ? `${res?.data[0]?.district_name}-${res?.data[0]?.district_code}` : '',
                        code:res?.data[0]?.district_code,
                        id:res?.data[0]?.district_id
                      },
                  });

                  let grampanchayat:boolean=false;
                if(stateCode){
                    grampanchayat= await isUsingGramPanchayatUtils(stateCode);
                }
                  setIsGramPanchayat(grampanchayat) 
                  if(grampanchayat){
                    setHealthBlockFormData((healthBlockSubDivLocationData: any) => ({
                      ...healthBlockSubDivLocationData,
                      villages_mapped: {
                        ...healthBlockSubDivLocationData.villages_mapped,
                        '#isVisible' : false,
                      },
                      gram_panchayat_mapped: {
                        ...healthBlockSubDivLocationData.gram_panchayat_mapped,
                        '#isVisible' : true,
                      }
                    }));
                  }
                  else{
                    setHealthBlockFormData((healthBlockSubDivLocationData: any) => ({
                      ...healthBlockSubDivLocationData,
                      villages_mapped: {
                        ...healthBlockSubDivLocationData.villages_mapped,
                        '#isVisible' : true,
                      },
                      gram_panchayat_mapped: {
                        ...healthBlockSubDivLocationData.gram_panchayat_mapped,
                        '#isVisible' : false,
                      }
                    }));
                  }

                //   const postWardParams={
                //     p_state_id:res?.data[0]?.state_id,
                //     p_ulb_ids:[],
                //     p_hbsd_ids:[]
                // }
                // const postVillageParams={
                //     p_state_id:res?.data[0]?.state_id,
                //     p_dist_id:res?.data[0]?.district_id,
                //     p_sub_dist_ids:[],
                //     p_block_ids:[],
                //     p_hbsd_ids:[],
                // }
                const response: any = await axios.getWithCache(`${endpoints.getHealthBlockAndSubDivTypes}`, Auth.loggedIn());
                setHealthBlockFormData((healthBlockDivision_details: any) => ({
                    ...healthBlockDivision_details,
                    type_name: {
                        ...healthBlockDivision_details.type_name,
                        '#options': response?.data?.data,
                    },
                }));
                await getAllDistrictsByStateId();
                await setSubDistrictByDistrictId();
                await setBlockByDistrictId();
                // await setULBByStateId();
                // await setAllVillage(postVillageParams);
                // await setAllGramPanchayat(postVillageParams);
                // await setAllWards(postWardParams);
                }
                catch(error:any){
                    errorLogger(error?.response?.data||error?.response||error)
                }
            }

        }
        initialFetch();
    },[])
    useEffect(()=>{
        if(healthBlockFormState.type_name.value==='Sub Division'){
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                health_block_name: {
                    ...healthBlockDivision_details.health_block_name,
                    '#title': 'Sub Division Name',
                },
            }));
        }
        else  if(healthBlockFormState.type_name.value==='Health Block'){
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                health_block_name: {
                    ...healthBlockDivision_details.health_block_name,
                    '#title': 'Health Block Name',
                },
            }));
        }
    },[healthBlockFormState.type_name.value])

    useEffect(()=>{      
        if(healthBlockFormState?.block?.value?.length > 0 && healthBlockFormState?.sub_district?.value?.length > 0){
            const postVillageParams={
                p_state_id:STATE_ID,
                p_dist_id:DISTRICT_ID,
                p_sub_dist_ids:healthBlockFormState?.sub_district?.id,
                p_block_ids:healthBlockFormState?.block?.id,
                p_hbsd_ids:[],
            }
            if(isGramPanchayat){
              setAllGramPanchayat(postVillageParams);
              setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                gram_panchayat_mapped: {
                    ...healthBlockDivision_details.gram_panchayat_mapped,
                    '#isDisabled': false
                },
            }));
            } else {
              setAllVillage(postVillageParams);
              setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                villages_mapped: {
                    ...healthBlockDivision_details.villages_mapped,
                    '#isDisabled': false
                },
            }));
            }            
        } else {
           setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                villages_mapped: {
                    ...healthBlockDivision_details.villages_mapped,
                    '#isDisabled': true,
                    '#options': [],
                },
            }));
        }

    },[healthBlockFormState?.block?.id,healthBlockFormState?.sub_district?.id]);

    useEffect(()=>{
        if(healthBlockFormState.ulb.value?.length>0){
            const postWardParams={
                p_state_id:STATE_ID,
                p_ulb_ids:healthBlockFormState.ulb.id,
                p_hbsd_ids:[]
            }
            setAllWards(postWardParams);
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                wards_mapped: {
                    ...healthBlockDivision_details.wards_mapped,
                    '#isDisabled': false
                },
            }));
        }
        else{
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                wards_mapped: {
                    ...healthBlockDivision_details.wards_mapped,
                    '#isDisabled': true,
                    '#options': [],
                },
            }));
        }

    },[healthBlockFormState.ulb.value]);

     useEffect(() => {
        const villagesLength = healthBlockFormState.villages_mapped.value.length;
        const gramPanchayatLength = healthBlockFormState.gram_panchayat_mapped.value.length;
        const wardsLength = healthBlockFormState.wards_mapped.value.length;
    
        const mainLocationLength = isGramPanchayat ? gramPanchayatLength : villagesLength;
    
        if (mainLocationLength === 0 && wardsLength === 0) {      
          setHealthBlockFormData((healthBlockDivision_details: any) => ({
            ...healthBlockDivision_details,
            villages_mapped: {
              ...healthBlockDivision_details.villages_mapped,
              '#required': true
            },
            gram_panchayat_mapped: {
              ...healthBlockDivision_details.gram_panchayat_mapped,
              '#required': true
            },
            wards_mapped: {
              ...healthBlockDivision_details.wards_mapped,
              '#required': true
            },
          }));
        }
        else if (mainLocationLength === 0 && wardsLength > 0) {
          setHealthBlockFormData((healthBlockDivision_details: any) => ({
            ...healthBlockDivision_details,
            villages_mapped: {
              ...healthBlockDivision_details.villages_mapped,
              '#required': false,
            },
            gram_panchayat_mapped: {
              ...healthBlockDivision_details.gram_panchayat_mapped,
              '#required': false
            },
            wards_mapped: {
              ...healthBlockDivision_details.wards_mapped,
              '#required': true
            },
          }));
          setHealthBlockFormState((healthBlockDivision_details: any) => ({
            ...healthBlockDivision_details,
            villages_mapped: {
              ...healthBlockDivision_details.villages_mapped,
              'isError': false,
            },
            gram_panchayat_mapped: {
              ...healthBlockDivision_details.gram_panchayat_mapped,
              'isError': false
            },
          }))
        }
        else if (mainLocationLength > 0 && wardsLength === 0) {
          setHealthBlockFormData((healthBlockDivision_details: any) => ({
            ...healthBlockDivision_details,
            villages_mapped: {
              ...healthBlockDivision_details.villages_mapped,
              '#required': true
            },
            gram_panchayat_mapped: {
              ...healthBlockDivision_details.gram_panchayat_mapped,
              '#required': true
            },
            wards_mapped: {
              ...healthBlockDivision_details.wards_mapped,
              '#required': false
            },
          }));
          
          setHealthBlockFormState((healthBlockDivision_details: any) => ({
            ...healthBlockDivision_details,
            wards_mapped: {
              ...healthBlockDivision_details.wards_mapped,
              'isError': false,
            },
          }))
        }
        else {      
          setHealthBlockFormData((healthBlockDivision_details: any) => ({
            ...healthBlockDivision_details,
            villages_mapped: {
              ...healthBlockDivision_details.villages_mapped,
              '#required': true
            },
            gram_panchayat_mapped: {
              ...healthBlockDivision_details.gram_panchayat_mapped,
              '#required': true
            },
            wards_mapped: {
              ...healthBlockDivision_details.wards_mapped,
              '#required': true
            },
          }));
        }
      }, [healthBlockFormState.villages_mapped.value, healthBlockFormState.gram_panchayat_mapped.value, healthBlockFormState.wards_mapped.value])
    

    const handleFormChange =  (value: string | boolean, key: string,option?:any,id?:any,code?:any) => {
        setErrors([true]);
        setHealthBlockFormState((prevState: any) => ({
            ...prevState,
          [key]: {
            ...prevState[key],
            value: value,
            isError: false,
            message: '',
            id:id,
            code:code
          },
        }));
    };
    const handleInputChange=_.debounce((value:string, key:string)=>{
        if(key === 'ulb'){
          setUlbInputText(value.trim());
        }
      },500);

    const contents = [
        <div key="zone-details">
            <ZoneForm
                formState={healthBlockFormState}
                formData={healthBlockFormData}
                handleFormChange={
                    (value: any, key: string, id: any, option: any, code: any) => {
                        const updateDropdownData = (dropdownData: any, setDropdownData: any, value: any, option: any) => {
                          id = [];
                          code = [];
                          option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
                            if (value.includes(op.value) && !dropdownData?.some((item: any) => item.id === op.id)) {
                              dropdownData.push({
                                value: op.value,
                                label: op.value,
                                id: op.id,
                                code: op.code
                              });
                            }
                          });

                          const selectedData = dropdownData?.filter((item: any) => value?.includes(item.value));
                          setDropdownData(selectedData);
                          id = selectedData?.map((item: any) => item.id);
                          code = selectedData?.map((item: any) => item.code);
                        };


                        switch (key.toLowerCase()) {
                          case 'gram_panchayat_mapped':{
                            updateDropdownData(grampanchayatDropDownData, setGrampanchayatDropDownData, value, option);
                            break;
                          }
                          case 'ulb':{
                            updateDropdownData(ulbDropDownData, setUlbDropDownData, value, option);
                            break;
                          }
                          case 'wards_mapped':{
                            updateDropdownData(wardsDropDownData, setWardsDropDownData, value, option);
                            break;
                          }
                          case 'block':{
                            updateDropdownData(blockDropDownData, setBlockDropDownData, value, option);
                            break;
                          }
                          case 'villages_mapped':{
                            updateDropdownData(villagesMappedDropDownData, setViillagesMappedDropDownData, value, option);
                            break;
                          }
                          case 'sub_district':{
                            updateDropdownData(subDistrictDropDownData, setSubDistrictDropDownData, value, option);
                            break;
                          }
                          default:
                            break;
                        }
                   handleFormChange(value, key, option, id, code)
               }
                }
                onInputChange={handleInputChange}
            />
        </div>
    ];
    const getAllDistrictsByStateId = async () => {
        if(STATE_ID){
            const districtsList = await axios.get(`${endpoints.getDistricts(STATE_ID)}`, Auth.loggedIn());
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                district: {
                    ...healthBlockDivision_details.district,
                    '#options':districtsList?.data?.data,
                },
            }));
        }
    }
    const setSubDistrictByDistrictId = async () => {
        if(DISTRICT_ID){
            const subDistrictsList = await axios.get(`${endpoints.getSubDistricts(DISTRICT_ID)}`, Auth.loggedIn());
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                sub_district: {
                    ...healthBlockDivision_details.sub_district,
                    '#options': subDistrictsList?.data?.data,
                },
            }));
        }
    }
    const setBlockByDistrictId = async () => {
        if(DISTRICT_ID){
            const blocksList = await axios.get(`${endpoints.getBlock(DISTRICT_ID)}`, Auth.loggedIn());
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                block: {
                    ...healthBlockDivision_details.block,
                    '#options': blocksList?.data?.data,
                },
            }));
        }
    }
    const fecthUlbBySearch = async (ulbInputText:string) => {
        const payload = {
          stateId : STATE_ID,
          searchText : ulbInputText,
        }
        const getUlbwithsearch = await axios.get(`${endpoints.fetchUlbByStateIdAndSearch(STATE_ID, ulbInputText)}`, Auth.loggedIn());
        const getUlb_options = getUlbwithsearch?.data.data?.map((key: any) => ({
          value: `${key.ulb_name}-${key.ulb_code}`,
          label: `${key.ulb_name}-${key.ulb_code}`,
          id: key.ulb_id,
          code: key.ulb_code,
        }));
        setHealthBlockFormData((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          ulb: {
            ...hierarchy_details_urban.ulb,
            '#options': getUlb_options,
            '#required': false,
            '#isDisabled': false,
          },
        }));
      }
    
      useEffect(()=>{
        if(STATE_ID && ulbInputText?.length >= 3){
          fecthUlbBySearch(ulbInputText)
        }
        if(ulbInputText?.length === 0)
        {
            setHealthBlockFormData((hierarchy_details_urban: any) => ({
            ...hierarchy_details_urban,
            ulb: {
              ...hierarchy_details_urban.ulb,
              '#options': [],
            },
          }));
        }
      },[ulbInputText])

    const setAllVillage = async (postVillageParams:any) => {
        if(postVillageParams.p_dist_id && postVillageParams.p_state_id){
            const allVillages = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`,postVillageParams, Auth.loggedInWithJSON());
            const village_options = allVillages?.data.data?.map((key: any) => ({
                value: `${key.village_name}-${key.village_code}`,
                label: `${key.village_name}-${key.village_code}`,
                id: key.village_id,
                code: key.village_code,
            }));
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                villages_mapped: {
                    ...healthBlockDivision_details.villages_mapped,
                    '#options': village_options
                },
            }));
        }
    }
    const setAllGramPanchayat = async (postGramPanchayatParams:any) => {
        if(postGramPanchayatParams.p_dist_id && postGramPanchayatParams.p_state_id){
            const allGramPanchayats = await axios.post(`${endpoints.getGrampanchayatByStateDistSubDisBlockId}`,postGramPanchayatParams, Auth.loggedInWithJSON());
            const gram_panchayat_options = allGramPanchayats?.data.data?.map((key: any) => ({
                value: `${key.gram_panchayat_name}-${key.gram_panchayat_code}`,
                label: `${key.gram_panchayat_name}-${key.gram_panchayat_code}`,
                id: key.gram_panchayat_id,
                code: key.gram_panchayat_code,
            }));
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                gram_panchayat_mapped: {
                    ...healthBlockDivision_details.gram_panchayat_mapped,
                    '#options': gram_panchayat_options,
                },
            }));
        }
    }

    const setAllWards = async (postWardParams:any) => {
        if(postWardParams.p_state_id){
            const allWards = await axios.post(`${endpoints.getWardsByStateUlb}`,postWardParams, Auth.loggedInWithJSON());
            const ward_options = allWards?.data.data?.map((key: any) => ({
                value: `${key.ward_name}-${key.ward_code}`,
                label: `${key.ward_name}-${key.ward_code}`,
                id: key.ward_id,
                code: key.ward_code,
            }));
            setHealthBlockFormData((healthBlockDivision_details: any) => ({
                ...healthBlockDivision_details,
                wards_mapped: {
                    ...healthBlockDivision_details.wards_mapped,
                    '#options': ward_options
                },
            }));
        }
    }
    const handleSave = async (activeItem: number) => {
        const tempError = [];
        let isSimilarName = false;
        if(healthBlockFormState.health_block_name.value!=='' && healthBlockFormState.district.id!==undefined){
        try{
          const response = await axios.get(`${endpoints.checkHealthBlockSubDivExist(healthBlockFormState.district.id,healthBlockFormState.health_block_name.value)}`, Auth.loggedIn());
          const data1=response.data?.data[0];
          isSimilarName=data1?.check_healthblock_subdiv_exists;
        }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
      }
    
      const tempChange = {
        ...healthBlockFormState
      };
      let isFormError = false;
      
      Object.keys(tempChange).map((item: string) => {
        
        if (item === "type_name") {
          if (!tempChange.type_name.value) {
            tempChange.type_name.isError = true;
            tempChange.type_name.message = validations[item];
            isFormError = true;
          }
          else{
            tempChange.type_name.isError = false;
          }
        }
        else if( item === "health_block_name"){
            if(!tempChange.health_block_name.value){
              tempChange.health_block_name.isError = true;
              if(healthBlockFormState.type_name.value==='Sub Division'){
                tempChange.health_block_name.message = validations["sub_division_name"];
              }
              else{
                tempChange.health_block_name.message = validations["health_block_name"];
              } 
              isFormError = true;
            }
            else if(isSimilarName){
              isFormError = true;
              tempChange.health_block_name.isError = true;
              tempChange.health_block_name.message = validations["zone_exists"];
            }
            else{
              tempChange.health_block_name.isError = false;
            }
          }
          else if(item === "effective_form_date"){
      
            if (!tempChange.effective_form_date.value) {
              tempChange.effective_form_date.isError = true;
              tempChange.effective_form_date.message = validations[item];
              isFormError = true;
              
            }
            else{
              tempChange.effective_form_date.isError = false;
              
            }
          }
          else if(item === "district" ){
            if (!tempChange.district.value) {
              tempChange.district.isError = true;
              tempChange.district.message = validations[item];
              isFormError = true;
              
            }
            else{
              tempChange.district.isError = false;
              
            }
          }
          else if(!isGramPanchayat){
            if (item === 'villages_mapped' || item === 'wards_mapped') {
                if (tempChange.villages_mapped.value.length === 0 && tempChange.wards_mapped.value.length === 0) {
                    tempChange.villages_mapped.isError = true;
                    tempChange.villages_mapped.message = validations['villages'];
                    tempChange.wards_mapped.isError = true;
                    tempChange.wards_mapped.message = validations['wards'];
                    isFormError = true;
                }
                else if (tempChange?.villages_mapped?.value?.length === 0 && tempChange?.wards_mapped?.value?.length > 0) {
                    tempChange.villages_mapped.isError = false;
                    tempChange.wards_mapped.isError = false;
                    tempChange.villages_mapped.message = ``;
                    tempChange.wards_mapped.message = ``;
                }
                else if (tempChange?.villages_mapped?.value?.length > 0 && tempChange?.wards_mapped?.value?.length === 0) {
                    tempChange.villages_mapped.isError = false;
                    tempChange.wards_mapped.isError = false;
                    tempChange.villages_mapped.message = ``;
                    tempChange.wards_mapped.message = ``;
                }
                else {
                    tempChange.wards_mapped.isError = false;
                    tempChange.villages_mapped.isError = false;
                }
            }
          }
        else if (isGramPanchayat) {
            if (item === 'gram_panchayat_mapped' || item === 'wards_mapped') {
                if (tempChange.gram_panchayat_mapped.value.length === 0 && tempChange.wards_mapped.value.length === 0) {
                    tempChange.gram_panchayat_mapped.isError = true;
                    tempChange.gram_panchayat_mapped.message = validations['gram_panchayat'];
                    tempChange.wards_mapped.isError = true;
                    tempChange.wards_mapped.message = validations['wards'];
                    isFormError = true;

                }
                else if (tempChange?.gram_panchayat_mapped?.value?.length === 0 && tempChange?.wards_mapped?.value?.length > 0) {
                    tempChange.gram_panchayat_mapped.isError = false;
                    tempChange.wards_mapped.isError = false;
                    tempChange.gram_panchayat_mapped.message = ``;
                    tempChange.wards_mapped.message = ``;
                }
                else if (tempChange?.gram_panchayat_mapped?.value?.length > 0 && tempChange?.wards_mapped?.value?.length === 0) {
                    tempChange.gram_panchayat_mapped.isError = false;
                    tempChange.wards_mapped.isError = false;
                    tempChange.gram_panchayat_mapped.message = ``;
                    tempChange.wards_mapped.message = ``;
                }
                else {
                    tempChange.wards_mapped.isError = false;
                    tempChange.gram_panchayat_mapped.isError = false;
                }
            }
        }
      });
      tempError[0] = isFormError;
      setHealthBlockFormState(tempChange);
      setErrors(tempError);
    }

    const finishHandler = async () => {
      try{
        const dateFormat=new Date(healthBlockFormState.effective_form_date.value);
        dateFormat.setDate(dateFormat.getDate()+1);
        const newDate=dateFormat.toISOString().split('T')[0]
        const postData: any = {
            "stCode": stateCode,
            "districtId": healthBlockFormState.district.id,
            "hbSdName": healthBlockFormState.health_block_name.value,
            "typeId": healthBlockFormState.type_name.id,
            "effectiveFromDt": newDate,
            "villageIds": !isGramPanchayat ? (healthBlockFormState.villages_mapped.id.length > 0 ? healthBlockFormState.villages_mapped.id : []) : [],
            "gramPanchayatIds": isGramPanchayat ? (healthBlockFormState.gram_panchayat_mapped.id.length > 0  ? healthBlockFormState.gram_panchayat_mapped.id : []): [],
            "wardIds": healthBlockFormState.wards_mapped.id.length > 0 ? healthBlockFormState.wards_mapped.id : [],
            "ulbIds":  [],
            "blockdIds":  [],
            "subDistIds":  [],
            "parentUserId": '',
            "parentUserTypeId": '',
        }

        const data: any = await manageHealthFacilityJson(JSON.parse(JSON.stringify(postData)))
        const mainPayload = data.mainPayload;
        const combinedChunks: any[] = data.combinedChunks;

        const compressedMainData = pako.gzip(JSON.stringify(mainPayload));
        const encodeCompressedMainData = await uint8ToBase64(compressedMainData);

        let response: any;
        if (combinedChunks.length > 0) {
          await axios.post(`${endpoints.insertHealthBlockAndSubDiv}`, {data: encodeCompressedMainData}, Auth.loggedInWithJSON()).then(async (res:any) => {
            if (res?.status === 200 && res?.data?.data && res?.data?.data.length > 0) {
              response = res;
              let subRes: any
              for (const value of combinedChunks) {
                try {
                  const compressedDataWithIds = value ? pako.gzip(JSON.stringify({hbSdId: res?.data.data[0].hb_sd_id,
                    stCode: postData.stCode, ...value})) : null;
                  const encodeCompressedDataWithIds = compressedDataWithIds ? await uint8ToBase64(compressedDataWithIds) : '';
                  subRes = await putDataJSON<any>(`${endpoints.updateHealthBlockAndSubDivEntity}`, {data: encodeCompressedDataWithIds})
                } catch (err) {
                  toast.warning("Some ward/villages details could not be saved, try again.", {
                    position: "top-center"
                  });
                }
              }
              response = subRes ? subRes : res;
            } else {
              response = res;
            }
          });
        } else {
          response = await axios.post(`${endpoints.insertHealthBlockAndSubDiv}`, {data: encodeCompressedMainData}, Auth.loggedInWithJSON());
        }
        // closeModal();
        if ((response?.status === 200 && response?.data?.data && response?.data?.data.length > 0) || response?.data) {
            navigate(`/healthblock`);
           
                toast.success("Records have been successfully created", {
                  position: "top-center"
                });
           
        }
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }

    useEffect(() => {
      setIsFormValidated(false);
    }, [activeIndex]);
    
    useEffect(() => {
    if (!errors[activeIndex] && isFormValidated) {
        const newFormCompleted = [...formCompleted];
        newFormCompleted[activeIndex] = true;
        setFormCompleted(newFormCompleted);
        const perc = (activeIndex + 1) * navs;
        setSelectedPerc(perc);
    }
    if (errors[activeIndex] && formCompleted[activeIndex]) {
        const newFormCompleted = [...formCompleted];
        newFormCompleted[activeIndex] = false;
        setFormCompleted(newFormCompleted);
    }
    }, [errors]);

    const breadcrumbItemName=[
        { value: page, label: 'Geographical Entities' },
        { value: page, label: `Health Block /Sub Division` },
    ];

    const onHandleBackArrowButton=()=>{
        navigate(`/healthblock`);
    };

    const handleNavClick = (index: number): void => {
        if (formCompleted[index]) {
          setActiveIndex(index);
        }
    };
    
    const handleSubmit = (): void => {
    handleSave(activeIndex);
    setIsFormValidated(true);
    };

    const CloseFacility=()=>{
    setCloseModal(true);
    };

    const closeCreateModal=(value:boolean)=>{
    if(value){
        setCloseModal(false);
        navigate(`/healthblock`);
    }
    else{
        setCloseModal(false);
    }
    };
    
    return (
        <>
            {/* <PageModal
                finishHandler={finishHandler}
                closeModal={closeModal}
                show={show}
                navItemsModal={['Enter Details']}
                contents={contents}
                title={'Create Health Block/Sub Division'}
                onSave={handleSave}
                errors={[...errors]}
                page='health-block'
            /> */}

            <CreateCommonComponent 
                title={'Create Health Block/Sub Division'}
                breadcrumbItemName={breadcrumbItemName} 
                onHandleBackArrowButton={onHandleBackArrowButton}
                navItemsModal={navItemsModal}
                activeIndex={activeIndex}
                handleNavClick={handleNavClick}
                formCompleted={formCompleted}
                headerName={`Create Health Block/Sub Division`}
                progressBarPerc={selectPerc}
                contents={contents}
                handleSubmit={handleSubmit}
                finishHandler={finishHandler}
                handleCancel={CloseFacility}
                closeCreateModal={closeCreateModal}
                closeModal={closeModal}
            />
        </>
    );

};
export default CreateNewNonGeo;